const allButtons = document.querySelectorAll('.partners-modal-button');


allButtons.forEach((button) => {
	button.addEventListener('click', (e) => {
		e.preventDefault();

		const modalId = button.querySelector('.description').dataset.modalId;

		if(modalId) {
			const modal = document.getElementById(modalId);

			if(modal) {
				modal.classList.add('show');
				modal.setAttribute('aria-modal', 'true');
				modal.removeAttribute('inert');
				modal.style.display = 'block';
				modal.setAttribute('role', 'dialog');
				modal.querySelector('.close-modal')?.focus();
				document.body.style.overflow = 'hidden';

				const closeButton = modal.querySelector('.close');
				if(closeButton) {
					closeButton.addEventListener('click', (e) => {
						e.preventDefault();
						closeModal(modal);
					})
				}

				modal.addEventListener('click', (e) => {
					if(!e.target.closest('.modal-dialog')) {
						closeModal(modal);
					}
				})
			}
		}
	})
})

function closeModal(modal) {
	modal.classList.remove('show');
	modal.setAttribute('inert', '');
	modal.removeAttribute('aria-modal');
	modal.removeAttribute('role');
	modal.style.display = 'none';
	document.body.style.overflow = '';
}
